import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { PermitApprovalAssignDTO } from '../types/permit-approval';
import { PermitApprovalCounterApiObject } from '../types/permit-approval-counter';
import { PermitApprovalApiObject } from '../types/permit-approval-response';

@Injectable({
  providedIn: 'root',
})
export class PermitsApprovalsHttpService {
  private readonly http = inject(HttpClient);

  public list$(companyID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/absences/approvals`;
    return this.http.get<PermitApprovalApiObject>(url, { params });
  }

  public counter$(companyID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/absences/approvals/summaries/counter`;
    return this.http.get<PermitApprovalCounterApiObject>(url);
  }

  public approve$(companyID: number, approvalID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/absences/approvals/${approvalID}/approves`;
    return this.http.patch<PermitApprovalApiObject>(url, null);
  }

  public reject$(companyID: number, approvalID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/absences/approvals/${approvalID}/rejects`;
    return this.http.patch<PermitApprovalApiObject>(url, null);
  }

  public flow$(companyID: number, employeeAbsenceID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/absences/${employeeAbsenceID}/approvals`;
    return this.http.get<PermitApprovalApiObject>(url);
  }

  public assign$(
    companyID: number,
    approvalID: number,
    assignment: PermitApprovalAssignDTO
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/absences/approvals/${approvalID}/assignments`;
    return this.http.patch<PermitApprovalApiObject>(url, assignment);
  }
}
